import { Component, OnInit, Input, SimpleChange, OnChanges, SimpleChanges, ɵConsole } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Sale } from 'src/app/models/Sale';
import { SaleService } from 'src/app/services/partner/sale.service';

@Component({
  selector: 'app-graf-skladisce-sale-drzave-pie',
  templateUrl: './graf-skladisce-sale-drzave-pie.component.html',
  styleUrls: ['./graf-skladisce-sale-drzave-pie.component.css']
})
export class GrafSkladisceSaleDrzavePieComponent implements OnInit, OnChanges {
  @Input() dataList: Array<Sale>;
  @Input() countryList;
  @Input() saleFilter;
  public countryListSubString = [];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          return '';
        },
      },
      legend: {
        position: 'top',
      },

      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.parsed.y;
            if (value >= 1000) {
              label += value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
              label += value;
            }
            return label;
          }
        }
      }
      

    },
    

  };
  public pieChartLabels: string[] = [];
  public pieChartData: number[];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];


  public countrySaleValList = [];
  constructor(private saleService: SaleService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.pieChartData = [];
    this.pieChartLabels = [];
    if(changes.saleFilter) {
      console.log(changes.saleFilter.currentValue);
      this.calculateCountrySum();
      this.spliceCountryName();
      this.pieChartData = this.countrySaleValList;
      this.pieChartLabels = this.countryListSubString;
    }
  }


  ngOnInit() {
    this.calculateCountrySum();
    this.spliceCountryName();
    this.pieChartData = this.countrySaleValList;
    this.pieChartLabels = this.countryListSubString;
  }

  spliceCountryName() {
    this.countryListSubString = [];
    for(let i = 0; i < this.countryList.length; i++) {
      if(this.countryList[i].length > 30){
        this.countryListSubString.push(this.countryList[i].substring(0, 30) + "...");
      } else {
        this.countryListSubString.push(this.countryList[i]);
      }

    }
  }

  calculateCountrySum() {
    this.countrySaleValList = [];
    console.log(this.dataList);
    console.log(this.countryList);
    let sum = 0;
    for(let j = 0; j < this.countryList.length; j++) {
     for(let i = 0; i < this.dataList.length; i++) {
       if(this.countryList[j] === this.dataList[i].country) {
        if(this.saleFilter === "SALEVALUE"){
          sum += this.dataList[i].saleVal;
        } else if(this.saleFilter === "MARGINPERCENT"){
          sum += this.dataList[i].marginPrc;
        } else if (this.saleFilter === 'SALEVALUEWT') {
          sum += this.dataList[i].saleValWT;
        } else if (this.saleFilter === 'QUANTITY') {
          sum += this.dataList[i].quantity;
        } else if (this.saleFilter === 'DOCUMENTCOUNT') {
          sum += this.dataList[i].docCount;
        } else if (this.saleFilter === 'ITEMCOUNT') {
          sum += this.dataList[i].itemCount;
        }
       }
      }
      this.countrySaleValList.push((this.roundingToolNoDecimal(sum)));
      sum = 0;
    }
  }

  roundingToolNoDecimal(num) {
    return Math.round(num);
  }


}
